import { Ajv, type ValidateFunction } from 'ajv'
import addErrors from 'ajv-errors'
import addFormats from 'ajv-formats'
import { translations } from '../translations/translations-manager'

const ajv = new Ajv({ allErrors: true })
addErrors(ajv)
addFormats(ajv)

/**
 * Validate input value against a schema.
 * @param schema Ajv validation schema
 * @param value Value to be validated
 * @returns Object containing the validation result and errors if any
 */
export function validateInput<T>(
  schema: Record<string, any>,
  value: T
): { valid: boolean, errors: Record<string, string> | undefined } {
  const validate: ValidateFunction = ajv.compile(schema)
  const valid = validate(value)
  return {
    valid,
    errors: !valid ? (validate.errors?.reduce((acc, item) => {
      if (item.keyword === 'required') {
        acc[item.params.missingProperty] = translations.texts.field_mandatory.toString()
      } else if (item.message) {
        acc[item.instancePath.slice(1)] = item.message
      }
      return acc
    }, {} as Record<string, string>)) : undefined,
  }
}
